import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Portfolio } from "@/components/Portfolio";
import { About } from "@/components/About";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/lib/api";

export default function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    if (hash) setTimeout(() => scrollToId(hash), 300);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [hash]);

  return (
    <main className="bg-ink text-foreground min-h-screen">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Portfolio />
      <About />
      <QuoteForm />
      <Footer />
    </main>
  );
}
